import {
  SubmitCheckoutIdentifyShopper,
  SubmitCheckoutChallengeShopper,
  SubmitGuestCheckoutIdentifyShopper,
  SubmitGuestCheckoutChallengeShopper,
} from '../../schemas/rql';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

const checkoutIdentifyShopper = gql`
  mutation SubmitCheckoutIdentifyShopper($input: Input_core_apimessages_CheckoutIdentifyShopperRequest) {
    checkoutIdentifyShopper(input: $input) {
      adyenPaymentResult {
        paymentStatus
        challengeToken
      }
      paymentResultUrl
    }
  }
`;

const checkoutChallengeShopper = gql`
  mutation SubmitCheckoutChallengeShopper($input: Input_core_apimessages_CheckoutChallengeShopperRequest) {
    checkoutChallengeShopper(input: $input) {
      adyenPaymentResult {
        paymentStatus
      }
      paymentResultUrl
    }
  }
`;


const guestCheckoutIdentifyShopper = gql`
  mutation SubmitGuestCheckoutIdentifyShopper($input: Input_core_apimessages_GuestCheckoutIdentifyShopperRequest) {
    guestCheckoutIdentifyShopper(input: $input) {
      adyenPaymentResult {
        paymentStatus
        challengeToken
      }
      paymentResultUrl
    }
  }
`;

const guestCheckoutChallengeShopper = gql`
  mutation SubmitGuestCheckoutChallengeShopper($input: Input_core_apimessages_GuestCheckoutChallengeShopperRequest) {
    guestCheckoutChallengeShopper(input: $input) {
      adyenPaymentResult {
        paymentStatus
      }
      paymentResultUrl
    }
  }
`;

export const connectGuestCheckoutIdentifyShopper =
  graphql<{}, SubmitGuestCheckoutIdentifyShopper.Mutation, SubmitGuestCheckoutIdentifyShopper.Variables>(
    guestCheckoutIdentifyShopper, {
      name: 'guestCheckoutIdentifyShopper',
      options: { ssr: false },
    },
  );

export const connectGuestCheckoutChallengeShopper =
  graphql<{}, SubmitGuestCheckoutChallengeShopper.Mutation, SubmitGuestCheckoutChallengeShopper.Variables>(
    guestCheckoutChallengeShopper,
    {
      name: 'guestCheckoutChallengeShopper',
      options: { ssr: false },
    },
  );

export const connectCheckoutIdentifyShopper =
  graphql<{}, SubmitCheckoutIdentifyShopper.CheckoutIdentifyShopper, SubmitCheckoutIdentifyShopper.Variables>(
    checkoutIdentifyShopper, {
      name: 'checkoutIdentifyShopper',
      options: { ssr: false },
    },
  );

export const connectCheckoutChallengeShopper =
  graphql<{}, SubmitCheckoutChallengeShopper.CheckoutChallengeShopper, SubmitCheckoutChallengeShopper.Variables>(
    checkoutChallengeShopper,
    {
      name: 'checkoutChallengeShopper',
      options: { ssr: false },
    },
  );



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/threeds2_checkout_operations.ts